


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import VueDraggableResizable from 'vue-draggable-resizable';
@Component({
  components: {
    VueDraggableResizable,
  },
})
export default class Drag extends Vue {
  @Prop({ default: false }) public isShow!: boolean;
  @Prop({ default: 150 }) public initY!: number;
  @Prop({ default: 50 }) public w!: number;
  @Prop({ default: 50 }) public h!: number;
  @Prop({ default: 50 }) public z!: number;
  @Prop({ default: () => {} }) public dragProp!: any;

  // 挂件宽度 高度
  public width = 0;
  public height = 0;
  // 可移动宽度 高度
  public maxX = 0;
  public maxY = 0;
  // 挂件左上角的x，y信息
  public y = 0;
  public x = 0;
  // 是否展示 需要判断是否新用户

  get dragCompProp() {
    const propList = ['active', 'preventDeactivation', 'disableUserSelect', 'enableNativeDrag'];
    return propList.reduce((acc, cur) => ({
      [cur]: this.dragProp[cur],
      ...acc,
    }), {});
  }
  @Watch('isShow')
  public isShowChange(val) {
    if (val) {
      this.init();
    }
  }
  public async mounted() {
    // 初始化节点信息
    if (!this.isShow) {
      return;
    }
    this.init();
  }
  public init() {
    this.$nextTick(() => {
      const ref = this.$refs.dragRef! as Vue;
      const el = ref.$el;
      this.maxX = window.screen.availWidth;
      this.maxY = window.screen.availHeight;
      this.width = el.clientWidth;
      this.height = el.clientHeight;

      // 初始位置在右边贴边
      this.y = this.initY;
      this.x = this.maxX - this.width;
    });
  }
  // 结束拖拽
  public onDragstop(x, y) {
    const gap = 100;

    // 吸顶
    if (y < gap) {
      this.x = x;
      return this.y = 0;
    }
    // 吸两边
    this.x = x > this.maxX / 2 ? this.maxX - this.width : 0;
    this.y = y;
  }
  // 拖拽中
  public onDrag(x, y) {
    this.y  = -1000;
    this.x = -1000;
    // 不能划出屏幕外判断
    if (x < 0 || y < 0) {
      return false;
    }
    if (x + this.width > this.maxX || y + this.height > this.maxY) {
      return false;
    }
    return true;
  }
}
